import { render } from "./Role.vue?vue&type=template&id=177be859&ts=true"
import script from "./Role.vue?vue&type=script&lang=ts"
export * from "./Role.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\ATTP_PC03\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__